import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InterviewsTab from '../components/messenger/InterviewsTab';
import InterviewsList from './InterviewsList';
import { ContentTabToggle } from '../components/ui/content-tab-toggle';

const InterviewsPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const modeParam = params.get('mode');
  const mode: 'interviews' | 'ai-screening' = modeParam === 'ai-screening' ? 'ai-screening' : 'interviews';

  const handleModeChange = (nextMode: 'interviews' | 'ai-screening') => {
    const nextParams = new URLSearchParams(location.search);
    if (nextMode === 'ai-screening') {
      nextParams.set('mode', 'ai-screening');
    } else {
      nextParams.delete('mode');
    }
    const nextSearch = nextParams.toString();
    navigate(
      { pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : '' },
      { replace: false }
    );
  };

  return (
    <div className="h-full">
      <div className="px-6 pt-6">
        <ContentTabToggle
          options={[
            { id: 'interviews', label: 'Собеседования' },
            { id: 'ai-screening', label: 'AI скрининг' },
          ]}
          activeTab={mode}
          onTabChange={handleModeChange}
          className="w-[347px]"
        />
      </div>
      <div className="pt-4">
        {mode === 'ai-screening' ? <InterviewsList /> : <InterviewsTab />}
      </div>
    </div>
  );
};

export default InterviewsPage;
